// 把脚本代码转为string
const code = `
function timedCount() {
  postMessage(true)
  setTimeout('timedCount()', 67)
}
self.addEventListener('message', function (e) {
  var data = e.data;
  switch (data.cmd) {
    case 'start':
      self.postMessage('收到开始命令');
      break;
    case 'stop':
      self.postMessage('收到结束命令');
      self.close(); // Terminates the worker.
      break;
    default:
      self.postMessage('未知命令');
  };
}, false);
timedCount()
`

const blob = new Blob([code], { type: 'application/javascript' })
const worker_script = URL.createObjectURL(blob)

export default worker_script
